import VueMeta from 'vue-meta'

const VueMetaPlugin = {
    install(Vue) {
        Vue.use(VueMeta)
    },
}

export default VueMetaPlugin
